// Logos du site (fichiers dans public/). Référencés via l'URL publique pour
// éviter d'avoir à les bundler.
//
// ⚠️ PIÈGE DE NOMMAGE : les noms désignent le FOND, pas la couleur de l'encre.
//   logowhite.png → encre SOMBRE, faite pour un fond clair (luminance ~38)
//   logoblack.png → encre CLAIRE, faite pour un fond sombre (luminance ~173)
// Mesuré le 05/09/2026. Ne pas se fier au nom du fichier.

// Encre sombre — sur fond clair. Logo par défaut, utilisé partout.
const logo = process.env.PUBLIC_URL + "/logowhite.png";

// Encre claire — sur fond sombre. Utilisé sur la home en version téléphone,
// où le contenu est posé sur une vidéo verticale.
export const logoOnDark = process.env.PUBLIC_URL + "/logoblack.png";

export default logo;
